import { wrapper } from "../../redux";
import { fetchSectionsServer } from "../../redux/action-creaters/sections";
import Sections from "../../components/pages/sections";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { getBaltexSections } from "../../redux/action-creaters/baltex";
import { checkIsBaltex } from "../../utils";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function SectionsPage({ scripts, host }) {
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <Sections section={null}></Sections>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ query, req, resolvedUrl }) => {
    await store.dispatch(
      await fetchSectionsServer(Boolean(query.reset), Redis),
    );
    store.dispatch(addBreadcrumb({ link: "/catalog/", name: "Каталог" }));

    const isBaltex = checkIsBaltex(
      req.headers["host-proxy"] || req.headers.host,
    );

    if (isBaltex) {
      await store.dispatch(getBaltexSections(Boolean(query.reset)));
    }

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.catalogIndex },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/catalog/",
    );
  }),
);
